import Notifications from './notificationsResources';
import transformError from '@/api/shared/transformers/errorTransformer';
import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';

function get() {
  return Notifications.get()
    .then(({ body: { notifications = [] } }) =>
      notifications.map(transformToCamelCase),
    )
    .catch(transformError);
}

function sendSeen(lastNotifID) {
  return Notifications.seen({ id: lastNotifID }, {})
    .then(({ body: { message } }) => message)
    .catch(transformError);
}

export default {
  get,
  sendSeen,
};
